export const BASE_URL = "http://10.113.113.193:8384/" + "api/v1/";
